module.exports = __webpack_public_path__ + "img/2.5bc67d8d.png";